<template>
	<van-tabbar v-if="show" v-model="active" active-color="#6d65c6" :border="true" inactive-color="#979799">
		<van-tabbar-item v-for="(k, key) in item" replace :to="k.router" :key="key">
			<span>{{ k.titleKey ? $t(k.titleKey) : '' }}</span>
			<template #icon="props">
				<van-icon :name="props.active ? k.icon.active : k.icon.noactive" size="23px" />
			</template>
		</van-tabbar-item>
	</van-tabbar>
</template>

<script>
export default {
	data() {
		return {
			show: false,
			active: 0,
			item: [
				{
					router: '/Home',
					titleKey: 'nav.home',
					icon: {
						active: 'home-o',
						noactive: 'home-o'
					}
				},
				{
					router: '/Choose',
					titleKey: 'nav.list',
					icon: {
						active: 'todo-list-o',
						noactive: 'todo-list-o'
					}
				},
				{
					router: '/Game',
					titleKey: 'nav.game',
					icon: {
						active: 'like-o',
						noactive: 'like-o'
					}
				},
				{
					router: '/Video',
					titleKey: 'nav.video',
					icon: {
						active: 'video-o',
						noactive: 'video-o'
					}
				},
				{
					router: '/Mine',
					titleKey: 'nav.mine',
					icon: {
						active: 'user-o',
						noactive: 'user-o'
					}
				}
			]
		};
	},
	methods: {},
	watch: {
		$route(to) {
			if (to.name == 'home') {
				this.active = 0;
				this.show = true;
			} else if (to.name == 'game') {
				this.active = 2;
				this.show = true;
			} else if (to.name == 'choose') {
				this.active = 1;
				this.show = true;
			} else if (to.name == 'video') {
				this.active = 3;
				this.show = true;
			} else if (to.name == 'mine') {
				this.active = 4;
				this.show = true;
			} else {
				this.show = false;
			}
		}
	},
	created() {
		if (this.$route.name == 'home') {
			this.active = 0;
			this.show = true;
		} else if (this.$route.name == 'game') {
			this.active = 1;
			this.show = true;
		} else if (this.$route.name == 'choose') {
			this.active = 2;
			this.show = true;
		} else if (this.$route.name == 'video') {
			this.active = 3;
			this.show = true;
		} else if (this.$route.name == 'mine') {
			this.active = 4;
			this.show = true;
		} else {
			this.show = false;
		}
	}
};
</script>

<style lang="less" scoped>
@tabbar-height: 110px;
@tabbar-img: 75px;
.van-tabbar {
	height: @tabbar-height;
}
.van-tabbar-item__icon img {
	height: @tabbar-img;
}
.van-tabbar-item {
	font-size: 26px;
}
.tui {
	width: 4rem;
	margin-top: -7.333vw;
	background-color: white;
	border-radius: 50%;
	border: 10px solid white;
	z-index: 10;
}
[class*='van-hairline']::after {
	border: none !important;
}
</style>
